import { Component, OnInit } from '@angular/core';
import { AppelsService } from '../../service/appels.service';
import { Certificate } from 'src/app/model/apprenantFode.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NewParcourCertificate } from 'src/app/model/NewParcourCertificate';
import { Route, Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { CohortesParcours } from 'src/app/model/cohorte-parcours.model';

@Component({
  selector: 'app-new-certificate',
  templateUrl: './new-certificate.component.html',
  styleUrls: ['./new-certificate.component.css'],
})
export class NewCertificateComponent implements OnInit {
  certificateForm!: FormGroup;
  isDuplicating = false;
  isLoadingDuplicatedImage = false;

  maxFileSize: number = 2097152;
  minSize: number = 102400;

  valid!: boolean;
  inValid!: boolean;
  error!: boolean;

  inValidId!: boolean;
  inValidName!: boolean;
  inValidShort!: boolean;
  inValidStartdate!: boolean;
  inValidEnddate!: boolean;
  urlCertificat!: boolean;
  invalidDisplayname!: boolean;
  invalidFullname!: boolean;
  invalidPlatforme!: boolean;
  invalidUrl!: boolean;
  invalidDescription!: boolean;
  invalidCohorte!: boolean; // Ajouter cette propriété
  invalidCategory!: boolean; // Ajouter cette propriété
  certificatCodes: any[] = [];
  file: File | null = null;
  platforms: string[] = ['Moodle', 'Coursera'];
  categorys!: any[];
  fileSize!: number;
  fileName: string = '';
  cohortes: CohortesParcours[] = [];
  showConfirmModal = false;

  constructor(
    private appelService: AppelsService,
    private fb: FormBuilder,
    private router: Router,
  ) {}
  ngOnInit(): void {
    this.certificateForm = this.fb.group({
      idcertificat: [''],
      name: ['', Validators.required],
      shortname: ['', Validators.required],
      fullname: ['', Validators.required],
      displayname: ['', Validators.required],
      urlCertificat: ['', Validators.required],
      plateforme: ['', Validators.required],
      enddate: ['', Validators.required],
      startdate: ['', Validators.required],
      cohorte: ['', Validators.required], //****************
      description: ['', Validators.required],
      certificatCode: [''], // 👈 AJOUT
      category: [''],
    });
    this.appelService
      .listCategory()
      .pipe()
      .subscribe({
        next: (response) => {
          this.categorys = response;
          this.checkForDuplication();
        },
        error: (err) => {
          // console.error('Error creating certificate',err);
        },
      });

    this.certificateForm
      .get('idcertificat')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.inValidId = false;
        }
      });
    this.certificateForm.get('name')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.inValidName = false;
      }
    });
    this.certificateForm.get('shortname')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.inValidShort = false;
      }
    });
    this.certificateForm.get('fullname')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.invalidFullname = false;
      }
    });
    this.certificateForm
      .get('displayname')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidDisplayname = false;
        }
      });
    this.certificateForm
      .get('urlCertificat')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidUrl = false;
        }
      });
    this.certificateForm.get('plateforme')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.invalidPlatforme = false;
      }
    });
    this.certificateForm.get('enddate')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.inValidEnddate = false;
      }
    });
    this.certificateForm.get('startdate')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.inValidStartdate = false;
      }
    });
    // Validation pour cohorte
    this.certificateForm.get('cohorte')?.valueChanges.subscribe((values) => {
      if (values && values.length > 0) {
        this.invalidCohorte = false;
      }
    });
    this.certificateForm
      .get('description')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidDescription = false;
        }
      });
    this.appelService.getAllCertificatCodes().subscribe({
    next: (codes) => (this.certificatCodes = codes),
    error: () => (this.certificatCodes = []),
  });
    this.loadCohortes();
  }

  // private checkForDuplication(): void {
  //   const source = history.state?.duplicateCertificate;
  //   if (!source) {
  //     return;
  //   }

  //   this.isDuplicating = true;

  //   this.certificateForm.patchValue({
  //     name: source.name ? `${source.name} (copie)` : '',
  //     shortname: source.shortname ?? '',
  //     fullname: source.fullname ?? '',
  //     displayname: source.displayname ?? '',
  //     urlCertificat: source.urlCertificat ?? '',
  //     plateforme: source.plateforme ?? '',
  //     description: source.description ?? '',
  //     category:
  //       source.certifcatCategory?.id ??
  //       source.category?.id ??
  //       '',
  //     // Volontairement NON prérempli : idcertificat, startdate, enddate, cohorte
  //   });
  // }

  private checkForDuplication(): void {
    const source = history.state?.duplicateCertificate;
    if (!source) {
      return;
    }

    this.isDuplicating = true;

    const categoryId =
      source.certifcatCategory?.id ??
      source.category?.id ??
      source.categoryId ??
      '';

    this.certificateForm.patchValue({
      name: source.name ? `${source.name} (copie)` : '',
      shortname: source.shortname ?? '',
      fullname: source.fullname ?? '',
      displayname: source.displayname ?? source.displayName ?? '',
      urlCertificat: source.urlCertificat ?? source.urlCertificate ?? '',
      plateforme: source.plateforme ?? '',
      description: source.description ?? '',
      category: categoryId,
    });

    if (source.urlImage) {
      this.duplicateImageFromUrl(source.urlImage);
    }
  }

  private duplicateImageFromUrl(url: string): void {
    this.isLoadingDuplicatedImage = true;

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Impossible de récupérer l'image (${res.status})`);
        }
        return res.blob();
      })
      .then((blob) => {
        const extension = blob.type.split('/')[1] || 'jpg';
        const generatedName = `image-dupliquee.${extension}`;

        const imageFile = new File([blob], generatedName, { type: blob.type });

        this.file = imageFile;
        this.fileSize = imageFile.size;
        this.fileName = imageFile.name;
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération de l'image à dupliquer :", err);
        // Le champ reste vide, l'utilisateur pourra choisir une image manuellement
      })
      .finally(() => {
        this.isLoadingDuplicatedImage = false;
      });
  }


  loadCohortes(): void {
    this.appelService.getAllCohortesParcours().subscribe({
      next: (cohortes: any[]) => {
        this.cohortes = cohortes;
        // console.log('Cohortes chargées avec succès:', this.cohortes);
      },
      error: (error: any) => {
        console.error('Erreur lors du chargement des cohortes:', error);
        this.cohortes = [];
      },
    });
  }

  getSelectedCohorte(): any {
    return this.certificateForm.get('cohorte')?.value || '';
  }

  onChange(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.file = file;

      this.fileSize = file.size;
      this.fileName = file.name;
    }
  }

  createNewCertificate() {
    if (this.certificateForm.valid) {
      const formCertif = new FormData();

      const formData = this.certificateForm.value;
      // Convertir ls dates en milliseconde
      const startDate = new Date(formData.startdate).getTime();
      const endDate = new Date(formData.enddate).getTime();

      const certificat = new NewParcourCertificate(
        formData.name,
        formData.shortname,
        formData.fullname,
        formData.displayname,
        Math.round(startDate / 1000),
        Math.round(endDate / 1000),
        formData.urlCertificat,
        formData.plateforme,
        formData.description,
        formData.idcertificat,
        formData.category,
      );

      if (this.file) {
        formCertif.append('file', this.file);
      }

      formCertif.append('newCertificate', JSON.stringify(certificat));

      this.appelService
        .createNewCertificate(formCertif)
        .pipe()
        .subscribe({
         next: (response) => {
            if (response.status == 200) {
              window.scrollTo(0, 0);
              this.valid = true;
              setTimeout(() => {
                this.closeMessageModal();
                this.router.navigate(
                  ['/dashboard/appels/sigui-certificat'],
                  { queryParams: { filter: 'parcours' } },
                );
              }, 2000);
            }
          },
        });
    } else {
      window.scrollTo(0, 0);

      this.inValid = true;

      const formValue = this.certificateForm.value;

      if (
        formValue['idcertificat'] == undefined ||
        formValue['idcertificat'] == null ||
        formValue['idcertificat'] == ''
      ) {
        this.inValidId = true;
      } else {
        this.inValidId = false;
      }
      if (
        formValue['name'] == undefined ||
        formValue['name'] == null ||
        formValue['name'] == ''
      ) {
        this.inValidName = true;
      } else {
        this.inValidName = false;
      }
      if (
        formValue['shortname'] == undefined ||
        formValue['shortname'] == null ||
        formValue['shortname'] == ''
      ) {
        this.inValidShort = true;
      } else {
        this.inValidShort = false;
      }
      if (
        formValue['displayname'] == undefined ||
        formValue['displayname'] == null ||
        formValue['displayname'] == ''
      ) {
        this.invalidDisplayname = true;
      } else {
        this.invalidDisplayname = false;
      }

      if (
        formValue['startdate'] == undefined ||
        formValue['startdate'] == null ||
        formValue['startdate'] == ''
      ) {
        this.inValidStartdate = true;
      } else {
        this.inValidStartdate = false;
      }
      if (
        formValue['enddate'] == undefined ||
        formValue['enddate'] == null ||
        formValue['enddate'] == ''
      ) {
        this.inValidEnddate = true;
      } else {
        this.inValidEnddate = false;
      }
      if (
        formValue['plateforme'] == undefined ||
        formValue['plateforme'] == null ||
        formValue['plateforme'] == ''
      ) {
        this.invalidPlatforme = true;
      } else {
        this.invalidPlatforme = false;
      }
      if (
        formValue['fullname'] == undefined ||
        formValue['fullname'] == null ||
        formValue['fullname'] == ''
      ) {
        this.invalidFullname = true;
      } else {
        this.invalidFullname = false;
      }
      if (
        formValue['urlCertificat'] == undefined ||
        formValue['urlCertificat'] == null ||
        formValue['urlCertificat'] == ''
      ) {
        this.invalidUrl = true;
      } else {
        this.invalidUrl = false;
      }
      if (
        formValue['description'] == undefined ||
        formValue['description'] == null ||
        formValue['description'] == ''
      ) {
        this.invalidDescription = true;
      } else {
        this.invalidDescription = false;
      }
    }
  }

  createNewCertificateImprove() {
    if (this.certificateForm.valid) {
      const formCertif = new FormData();
      const formData = this.certificateForm.getRawValue();
      // console.log('Données du formulaire:', formData);

      // Validation des champs obligatoires
      if (!formData.idcertificat || !formData.category || !formData.cohorte) {
        console.error('Champs obligatoires manquants:', {
          idcertificat: formData.idcertificat,
          category: formData.category,
          cohorte: formData.cohorte,
        });
        this.error = true;
        return;
      }

      // Convertir les dates en secondes (timestamps Unix)
      const startDate = new Date(formData.startdate).getTime();
      const endDate = new Date(formData.enddate).getTime();

      const certificat = {
        name: formData.name,
        shortname: formData.shortname,
        fullname: formData.fullname,
        displayname: formData.displayname,
        startdate: Math.round(startDate / 1000),
        enddate: Math.round(endDate / 1000),
        urlCertificat: formData.urlCertificat,
        plateforme: formData.plateforme,
        description: formData.description,
        cohort: formData.cohorte,
        externalId: formData.idcertificat,
        category: formData.category,
        certificatCode: formData.certificatCode,   // 👈 AJOUT
      };

      // const certificat = new NewParcourCertificate(
      //   formData.name,
      //   formData.shortname,
      //   formData.fullname,
      //   formData.displayname,
      //   Math.round(startDate / 1000),
      //   Math.round(endDate / 1000),
      //   formData.urlCertificat,
      //   formData.plateforme,
      //   formData.description,
      //   formData.cohorte,
      //   formData.idcertificat,
      //   formData.category,
      // );
      // console.log(certificat);
      // console.log('Objet certificat créé:', certificat);

      if (this.file) {
        formCertif.append('file', this.file);
      } else {
        console.warn('Aucun fichier sélectionné');
      }

      const jsonData = JSON.stringify(certificat);
      // console.log('JSON à envoyer:', jsonData);
      formCertif.append('newCertificate', jsonData);

      // Log du contenu de FormData (pour debug)
      /*console.log('Contenu FormData:');
      formCertif.forEach((value, key) => {
        if (value instanceof File) {
          console.log(`  ${key}: File(${value.name}, ${value.size} bytes)`);
        } else {
          console.log(`  ${key}: ${value}`);
        }
      });*/

      this.appelService
        .createNewCertificateImprove(formCertif)
        .pipe()
        .subscribe({
          next: (response) => {
            if (response.status == 200) {
              window.scrollTo(0, 0);
              this.valid = true;
              setTimeout(() => {
                this.closeMessageModal();
                this.router.navigate(
                  ['/dashboard/appels/sigui-certificat'],
                  { queryParams: { filter: 'parcours' } },
                );
              }, 2000);
            }
          },
          error: (err) => {
            console.error('Erreur lors de la création du certificat:', err);
            console.error("Détails de l'erreur:", {
              status: err.status,
              statusText: err.statusText,
              url: err.url,
              message: err.error?.message || err.message,
              error: err.error,
            });
            this.error = true;
            setTimeout(() => {
              this.closeMessageModal();
            }, 2000);
          },
        });
    } else {
      console.warn('Formulaire invalide');
      // console.log('État du formulaire:', this.certificateForm.value);
      // console.log('Erreurs de validation:', this.certificateForm.errors);

      // Log des erreurs de champs spécifiques
      /*Object.keys(this.certificateForm.controls).forEach((key) => {
        const control = this.certificateForm.get(key);
        if (control && control.errors) {
          console.log(`Erreur sur ${key}:`, control.errors);
        }
      });*/

     window.scrollTo(0, 0);
      this.inValid = true;
      setTimeout(() => {
        this.closeMessageModal();
      }, 2000);

      const formValue = this.certificateForm.value;

      if (!formValue['cohorte']) {
        this.invalidCategory = true;
      } else {
        this.invalidCategory = false;
      }

      if (
        formValue['idcertificat'] == undefined ||
        formValue['idcertificat'] == null ||
        formValue['idcertificat'] == ''
      ) {
        this.inValidId = true;
      } else {
        this.inValidId = false;
      }
      if (
        formValue['name'] == undefined ||
        formValue['name'] == null ||
        formValue['name'] == ''
      ) {
        this.inValidName = true;
      } else {
        this.inValidName = false;
      }
      if (
        formValue['shortname'] == undefined ||
        formValue['shortname'] == null ||
        formValue['shortname'] == ''
      ) {
        this.inValidShort = true;
      } else {
        this.inValidShort = false;
      }
      if (
        formValue['displayname'] == undefined ||
        formValue['displayname'] == null ||
        formValue['displayname'] == ''
      ) {
        this.invalidDisplayname = true;
      } else {
        this.invalidDisplayname = false;
      }

      if (
        formValue['startdate'] == undefined ||
        formValue['startdate'] == null ||
        formValue['startdate'] == ''
      ) {
        this.inValidStartdate = true;
      } else {
        this.inValidStartdate = false;
      }
      if (
        formValue['enddate'] == undefined ||
        formValue['enddate'] == null ||
        formValue['enddate'] == ''
      ) {
        this.inValidEnddate = true;
      } else {
        this.inValidEnddate = false;
      }
      if (
        formValue['plateforme'] == undefined ||
        formValue['plateforme'] == null ||
        formValue['plateforme'] == ''
      ) {
        this.invalidPlatforme = true;
      } else {
        this.invalidPlatforme = false;
      }
      if (
        formValue['fullname'] == undefined ||
        formValue['fullname'] == null ||
        formValue['fullname'] == ''
      ) {
        this.invalidFullname = true;
      } else {
        this.invalidFullname = false;
      }
      if (
        formValue['urlCertificat'] == undefined ||
        formValue['urlCertificat'] == null ||
        formValue['urlCertificat'] == ''
      ) {
        this.invalidUrl = true;
      } else {
        this.invalidUrl = false;
      }

      if (
        formValue['description'] == undefined ||
        formValue['description'] == null ||
        formValue['description'] == ''
      ) {
        this.invalidDescription = true;
      } else {
        this.invalidDescription = false;
      }

      this.validateFormFields(formValue);
    }
  }

  openConfirmModal() {
    if (this.certificateForm.valid) {
      this.showConfirmModal = true;
    } else {
      this.createNewCertificateImprove();
    }
  }

  cancelSubmit() {
    this.showConfirmModal = false;
  }

  closeMessageModal() {
    this.valid = false;
    this.error = false;
    this.inValid = false;
  }

  confirmSubmit() {
    this.showConfirmModal = false;
    this.createNewCertificateImprove();
  }

  private validateFormFields(formValue: any) {
    const fieldsToValidate = [
      { name: 'idcertificat', invalidFlag: 'inValidId' },
      { name: 'name', invalidFlag: 'inValidName' },
      { name: 'shortname', invalidFlag: 'inValidShort' },
      { name: 'displayname', invalidFlag: 'invalidDisplayname' },
      { name: 'startdate', invalidFlag: 'inValidStartdate' },
      { name: 'enddate', invalidFlag: 'inValidEnddate' },
      { name: 'plateforme', invalidFlag: 'invalidPlatforme' },
      { name: 'fullname', invalidFlag: 'invalidFullname' },
      { name: 'urlCertificat', invalidFlag: 'invalidUrl' },
      { name: 'description', invalidFlag: 'invalidDescription' },
    ];

    fieldsToValidate.forEach((field) => {
      const value = formValue[field.name];
      const isInvalid = !value || value.trim() === '';
      (this as any)[field.invalidFlag] = isInvalid;
      if (isInvalid) {
        console.error(`${field.name} manquant ou vide`);
      }
    });
  }

  resetCreation() {
    this.certificateForm.reset();

    setTimeout(() => {
      this.router.navigate(
  ['/dashboard/appels/sigui-certificat'],
  {
    queryParams: {
      filter: 'parcours'
    }
  }
);
    }, 1000);
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    {
      label: 'GESTION DES CERTIFICATS ET WEBINAIRES',
      url: '/dashboard/appels/sigui-certificat',
    },
    {
      label: 'AJOUTER UN NOUVEAU CERTIFICAT',
      url: '/dashboard/appels/newcertificate',
    },
  ];
}
